import Vue from "vue";
import Router from "vue-router";
import auth from "@/helpers/auth";

Vue.use(Router);

const isAuth = (to, from, next) => {
  if (!auth.loggedIn()) {
    // Cek apakah query 'redirect' sudah ada di path tujuan
    if (to.name !== "login" || !to.query.redirect) { 
      window.location.replace(process.env.VUE_APP_HOMEPAGE + "logout?redirect=login")
      // next({
      //   name: "login",
      //   query: { redirect: to.fullPath }
      // });
    } else {
      next(); // Jika sudah di halaman login dengan query 'redirect', jangan tambahkan lagi
    }
  } else {
    next();
  }
};

const isUnauth = (to, from, next) => {
  if (auth.loggedIn()) {
    if (from.name == null) {
      next({ name: "home" });
    } else {
      next({ name: from.name });
    }
  } else {
    next();
  }
};

const notSeller = (to, from, next) => {
  isAuth(to, from, next);
  const user = auth.getUserData();
  if (user.user_store_id) {
    next({
      name: "profile"
    });
  } else {
    next();
  }
};

const isSeller = (to, from, next) => {
  isAuth(to, from, next);
  const user = auth.getUserData();
  if (!user.user_store_id) {
    next({
      name: "buka-toko24"
    });
  } else {
    next();
  }
};

const isStockist = (to, from, next) => {
  isAuth(to, from, next);
  const user = auth.getUserData();
  if (user.user_is_stockist.toLowerCase() === "true") {
    next();
  } else {
    next({
      name: "seller-dashboard"
    });
  }
};

export default new Router({
  mode: "history",
  duplicateNavigationPolicy: "ignore",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/connect",
      component: () => import("@/components/layout/store/Auth.vue"),
      children: [
        {
          path: "/connect",
          name: "connect",
          component: () => import("@/views/connect.vue")
        }
      ]
    },
    {
      path: "/disconnect",
      component: () => import("@/components/layout/store/Auth.vue"),
      children: [
        {
          path: "/disconnect",
          name: "disconnect",
          component: () => import("@/views/disconnect.vue")
        }
      ]
    },
    {
      path: "/login",
      component: () => import("@/components/layout/store/Auth.vue"),
      children: [
        {
          path: "/login",
          name: "login",
          beforeEnter: isUnauth,
          component: () => import("@/views/store/login/Login.vue")
        }
      ]
    },
    {
      path: "/admin/invoice_po/:id",
      name: "admin-invoice-po",
      component: () => import("@/views/seller/store/invoice/InvoicePoAdmin.vue")
    },
    {
      path: "/admin/shipping-label/:id",
      name: "admin-shipping-label",
      component: () => import("@/views/seller/store/invoice/shippingLabelAdmin.vue")
      // component: () => import('@/views/seller/store/invoice/InvoicePoAdmin.vue')
    },
    {
      path: "/sso/:token",
      name: "sso",
      component: () => import("@/views/store/login/LoginSso.vue")
    },
    {
      path: "/register",
      component: () => import("@/components/layout/store/Auth.vue"),
      children: [
        {
          path: "/register/",
          name: "register",
          beforeEnter: isUnauth,
          component: () => import("@/views/store/Register.vue")
        }
      ]
    },
    {
      path: "/ubah-password",
      component: () => import("@/components/layout/store/Auth.vue"),
      children: [
        {
          path: "/ubah-password",
          name: "ubah-password",
          beforeEnter: isUnauth,
          component: () => import("@/views/store/login/UbahPassword.vue")
        },
        {
          path: "/ubah-password/:token",
          name: "ubah-password-token",
          beforeEnter: isUnauth,
          component: () => import("@/views/store/login/ConfirmPassword.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/components/layout/store/Main.vue"),
      children: [
        {
          path: "/",
          name: "home",
          // redirect:'/profile',
          component: () => import("@/views/store/profile/Profile.vue"),
          beforeEnter: isAuth
        },
        {
          path: "/r/:referral?",
          name: "register-referal",
          component: () => import("@/views/store/home/Home.vue")
        },
        // {
        // 	path: 'product/:id?-:slug?',
        // 	name: 'product-detail',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/product/Product.vue')
        // },
        // {
        // 	path: 'product/:id?-:slug?/:referral?',
        // 	name: 'product-referal',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/product/Product.vue')
        // },
        // {
        // 	path: 'exclusive-product/:id?-:slug?',
        // 	name: 'exclusive-product',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/product/ExclusiveProduct.vue')
        // },
        // {
        // 	path: 'search',
        // 	name: 'search',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/product/AllProduct.vue')
        // },
        // {
        // 	path: 'store/:slug/:referral?',
        // 	name: 'store-detail',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/store/Store.vue')
        // },
        // {
        // 	path: 'wishlist',
        // 	name: 'wishlist',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/profile/Wishlist.vue'),
        // 	beforeEnter: isAuth,
        // },
        // {
        // 	path: 'cart',
        // 	name: 'cart',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/cart/Cart.vue'),
        // 	beforeEnter: isAuth,
        // },
        // {
        // 	path: 'checkout',
        // 	name: 'checkout',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/cart/Checkout.vue'),
        // 	beforeEnter: isAuth,
        // },
        {
          path: "countdown",
          name: "countdown",
          // redirect:'/profile',
          component: () => import("@/views/store/cart/Countdown.vue")
        },
        // {
        // 	path: 'payment-succes',
        // 	name: 'payment-succes',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/cart/PaymentSucces.vue'),
        // },
        // {
        // 	path: 'payment-pending',
        // 	name: 'payment-pending',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/cart/PaymentPending.vue'),
        // },
        // {
        // 	path: 'payment-store',
        // 	name: 'payment-store',
        // 	redirect:'/profile',
        // 	component: () => import('@/views/store/cart/PaymentOnStore.vue'),
        // 	beforeEnter: isAuth,
        // },
        {
          path: "profile",
          name: "profile",
          component: () => import("@/views/store/profile/Profile.vue"),
          beforeEnter: isAuth
        },
        {
          path: "address-list",
          name: "address-list",
          component: () => import("@/views/store/profile/Profile.vue"),
          beforeEnter: isAuth
        },
        {
          path: "/user/wallet-bonus",
          name: "user-wallet-bonus",
          component: () => import("@/views/store/penghasilan_bonus/penghasilanSaya.vue"),
          beforeEnter: isAuth
        },
        {
          path: "/user/rekening-bank",
          name: "user-rekening-bank",
          component: () => import("@/views/store/penghasilan_bonus/rekeningBank.vue"),
          beforeEnter: isAuth
        },
        {
          path: "afiliasi",
          name: "listAfiliasi",
          component: () => import("@/views/store/profile/DataDownline.vue"),
          beforeEnter: isAuth
        },
        {
          path: "history-coin-gen",
          name: "historyCoinGen",
          component: () => import("@/views/store/profile/HistoryCoinGen.vue"),
          beforeEnter: isAuth
        },
        {
          path: "dashboard",
          name: "dashboard",
          component: () => import("@/views/store/profile/Dashboard.vue"),
          beforeEnter: isAuth
        },
        {
          path: "transaction",
          name: "transaction",
          component: () => import("@/views/store/profile/Transaction.vue"),
          beforeEnter: isAuth
        },
        {
          path: "tempo-transaction",
          name: "tempo-transaction",
          component: () => import("@/views/store/profile/TransactionTempo.vue"),
          beforeEnter: isAuth
        },
        {
          path: "tempo-payment-transaction",
          name: "tempo-payment",
          component: () => import("@/views/store/profile/TempoPayment.vue"),
          beforeEnter: isAuth
        },
        {
          path: "nego-history-transaction",
          name: "nego-history",
          component: () => import("@/views/store/profile/NegoHistory.vue"),
          beforeEnter: isAuth
        },
        {
          path: "transaction/:id?",
          name: "transaction-detail",
          component: () => import("@/views/store/profile/TransactionDetail.vue"),
          beforeEnter: isAuth
        },
        {
          path: "invoice/:id?",
          name: "invoice",
          component: () => import("@/views/store/invoice/Invoice.vue"),
          beforeEnter: isAuth
        },
        {
          path: "buka-toko24",
          name: "buka-toko24",
          component: () => import("@/views/store/profile/BukaTokoKiriminaja.vue"),
          beforeEnter: notSeller
        },
        {
          path: "inbox",
          name: "inbox",
          component: () => import("@/views/store/profile/Inbox.vue"),
          beforeEnter: isAuth
        },
        {
          path: "accept-orders",
          name: "accept-orders",
          component: () => import("@/views/store/profile/AcceptOrders.vue"),
          beforeEnter: isAuth
        },
        {
          path: "page/:slug",
          name: "faq",
          component: () => import("@/views/store/Faq.vue")
        }
      ]
    },
    {
      path: "/seller/cetak-katalog",
      beforeEnter: isSeller,
      name: "print-catalog",
      component: () => import("@/views/seller/store/pembelian/cetakKatalog.vue")
    },
    {
      path: "/seller",
      beforeEnter: isSeller,
      component: () => import("@/components/layout/store/SellerDesk.vue"),
      redirect: "/seller/dashboard",
      children: [
        {
          path: "/seller/dashboard",
          name: "seller-dashboard",
          component: () => import("@/views/seller/store/dashboard/Dashboard.vue")
        },
        {
          path: "/seller/produk-saya",
          name: "seller-produk",
          component: () => import("@/views/seller/store/produk/produkList.vue")
        },
        {
          path: "/seller/produk-eksklusif",
          name: "seller-produk-eksklusif",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/produk/produkInternal.vue")
        },
        {
          path: "/seller/tambah-produk",
          name: "seller-produk-tambah",
          component: () => import("@/views/seller/store/produk/tambahProduk.vue")
        },
        {
          path: "/seller/ubah-produk/:id-:slug",
          name: "seller-produk-ubah",
          component: () => import("@/views/seller/store/produk/ubahProduk.vue")
        },
        {
          path: "/seller/slider/data",
          name: "seller-slider-data",
          component: () => import("@/views/seller/store/slider/list.vue")
        },
        {
          path: "/seller/slider/tambah",
          name: "seller-slider-tambah",
          component: () => import("@/views/seller/store/slider/tambah.vue")
        },
        {
          path: "/seller/slider/ubah/:id-:slug",
          name: "seller-slider-ubah",
          component: () => import("@/views/seller/store/slider/ubah.vue")
        },
        {
          path: "/seller/pengaturan-pengiriman",
          name: "seller-pengaturan-kirim",
          component: () => import("@/views/seller/store/pengiriman/pengaturanKirim.vue")
        },
        {
          path: "/seller/pesanan-saya",
          name: "seller-pesanan-saya",
          component: () => import("@/views/seller/store/pesanan/pesananList.vue")
        },
        {
          path: "/seller/pesanan-tempo",
          name: "seller-pesanan-tempo",
          component: () => import("@/views/seller/store/pesananTempo/pesananList.vue")
        },
        {
          path: "/seller/verifikasi-pembayaran",
          name: "seller-verifikasi-pembayaran",
          component: () => import("@/views/seller/store/verifikasiPembayaran/pesananList.vue")
        },
        {
          path: "/seller/riwayat-nego-produk",
          name: "seller-riwayat-nego-produk",
          component: () => import("@/views/seller/store/riwayatNegoProduk/index.vue")
        },
        {
          path: "/seller/pembelian",
          name: "seller-pembelian",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/pembelian/pembelianList.vue")
        },
        {
          path: "/seller/pembelian/tambah",
          name: "seller-tambah-pembelian",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/pembelian/formPembelian.vue")
        },
        {
          path: "/seller/pembelian/tambah-v2",
          name: "seller-tambah-pembelianv2",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/pembelian/formPembelianDisplay.vue")
        },
        {
          path: "/seller/pembelian/tambah-v3",
          name: "seller-tambah-pembelianv3",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/pembelian/formPembelianDisplayV3.vue")
        },
        // {
        // 	path: '/seller/penghasilan-saya',
        // 	name: 'seller-penghasilan',
        // 	component: () => import('@/views/seller/store/penghasilan/penghasilanSaya.vue')
        // },
        {
          path: "/seller/penghasilan-saya",
          name: "seller-penghasilan",
          component: () => import("@/views/seller/store/penghasilanNoWd/penghasilanSaya.vue")
        },
        {
          path: "/seller/deposit-reseller",
          name: "seller-deposit-reseller",
          beforeEnter: isStockist,
          component: () => import("@/views/seller/store/penghasilan/depositReseller.vue")
        },
        {
          path: "/seller/rekening-bank",
          name: "seller-rekening-bank",
          component: () => import("@/views/seller/store/penghasilan/rekeningBank.vue")
        },
        {
          path: "/seller/profile-toko",
          name: "seller-profile-toko",
          component: () => import("@/views/seller/store/profil/profileSeller.vue")
        },
        {
          path: "/seller/profile-toko-v3",
          name: "seller-profile-toko-v3",
          component: () => import("@/views/seller/store/profilv3/profileSeller.vue")
        },
        {
          path: "/seller/invoice/:id",
          name: "seller-invoice",
          component: () => import("@/views/seller/store/invoice/Invoice.vue")
        },
        {
          path: "/seller/shipping-label/:id",
          name: "seller-label",
          component: () => import("@/views/seller/store/invoice/shippingLabel.vue")
        },

        {
          path: "/seller/invoice_po/:id",
          name: "seller-invoice-po",
          component: () => import("@/views/seller/store/invoice/InvoicePo.vue")
        }
      ]
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("@/components/layout/store/Main.vue"),
      children: [
        {
          path: "*",
          component: () => import("@/views/404.vue")
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
